module.exports = "//static.hsappstatic.net/ecosystem-marketplace-solutions-base/static-1.14647/img/hubspot-logo.svg"